import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { RxCross2 } from "react-icons/rx";
import { FaBarsStaggered } from "react-icons/fa6";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
    window.scrollTo(0, 0);
  };

  // Change navbar background and logo after scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Check initial scroll position
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Disable body scroll when mobile menu is open
  useEffect(() => {
    if (window.innerWidth <= 992 && menuOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    };
  }, [menuOpen]);

  return (
    <header className={`nav-wrapper ${scrolled ? "scrolled" : ""}`}>
      <nav className="navbar_div">

        <div className="nav_logo">
          <img
            src={scrolled ? "/kaveri-logo.webp" : "/kaveri-logo-bg.webp"}
            alt="Kaveri Group Logo"
            className="logo-cover-img"
             width="300"
                         height="200"
                        loading="lazy"
                         decoding="async"
          />
        </div>

        <ul className={menuOpen ? "nav-links active" : "nav-links"}>

          <li>
            <NavLink
              to="/"
              onClick={() => handleNavigate("/")}
            >
              Home
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/about-us"
              onClick={() => handleNavigate("/about-us")}
            >
              About Us
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/project"
              onClick={() => handleNavigate("/project")}
            >
              Project
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/resources"
              onClick={() => handleNavigate("/resources")}
            >
              Resources
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/careers"
              onClick={() => handleNavigate("/careers")}
            >
              Careers
            </NavLink>
          </li>
           <li>
            <NavLink
              to="/review"
              onClick={() => handleNavigate("/review")}
            >
              Review
            </NavLink>
          </li>

          <li className="mobile-btn">
            <button
              className="nav-btn"
              onClick={() => handleNavigate("/contact-us")}
            >
              Contact Us
            </button>
          </li>

        </ul>

        <div className="nav-right">

          <NavLink to="/contact-us" className="desktop-btn">
            <button className="nav-btn">
              Contact Us
            </button>
          </NavLink>

          <div
            className="menu-icon"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <RxCross2 /> : <FaBarsStaggered />}
          </div>

        </div>

      </nav>
    </header>
  );
};

export default Navbar;